import React from 'react';
import { CustomDateGroup }
    from "Flow2/components/CustomCollections/CustomBox/CustomDataBox/CustomDataBox";
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import StoreHelper from 'Flow2/components/Article/Helpers/StoreHelper';
import './DateGroup';

class DateGroup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            customDataObjects: {}
        }
    }

    onDateChange = (name, date) => {
        try {
            const { customDataObjects } = this.state;
            let localDate = DataUtil.changeTime(date);
            this.setState({ [name]: localDate, customDataObjects: { ...customDataObjects, [name]: localDate } });
            if (this.props.freeType && this.props.updateCallback) {
                // name = DataUtil.subStringBefore(name, "From");
                this.props.updateCallback(name, localDate);
            } else {
                StoreHelper.checkAndUpdateDataObj({
                    updateDataObjects: this.props.updateDataObjects,
                    mainObj: this.props.mainObj, subObjName: this.props.subObjName,
                    name: name, value: localDate
                });
            }
        } catch (error) {
            console.log("ERROR: onDateChange!");
        }
    };

    setUpSavedData = () => {
        const { current, item } = this.props;
        if (current) {
            const { customDataObjects } = this.state;
            let currentFrom, currentTo;
            currentFrom = current;
            currentTo = current;
            if (current.from) currentFrom = current.from;
            if (current.to) currentTo = current.to;
            this.setState({
                [`${item.name}From`]: currentFrom,
                [`${item.name}To`]: currentTo,
                customDataObjects: {
                    ...customDataObjects,
                    [`${item.name}From`]: currentFrom, [`${item.name}To`]: currentTo
                }
            });
        }

    }

    componentDidUpdate(prev) {
        if (prev.current != this.props.current) {
            this.setUpSavedData();
        }
    }

    componentDidMount() {
        this.setUpSavedData();
    }

    render() {
        const { item } = this.props;
        return (
            <div className="DateGroup">
                <CustomDateGroup uiConfig={this.props.uiConfig ? this.props.uiConfig : null} hideLabel={this.props.hideLabel}
                    fMsgId={item.intl} lg={this.props.lg} requiredField={this.props.isRequired}
                    datePosFirst={this.props.datePosFirst} datePosSecond={this.props.datePosSecond}
                    minDate={item.minDate ? item.minDate : null} maxDate={item.maxDate ? item.maxDate : null}
                    selectedFrom={this.state.customDataObjects[`${item.name}From`]} selectedTo={this.state.customDataObjects[`${item.name}To`]}
                    onChangeFrom={this.onDateChange.bind(this, `${item.name}From`)} onChangeTo={this.onDateChange.bind(this, `${item.name}To`)} />
            </div>)
    }
}

export default DateGroup;